import React, { useEffect, useState } from "react";
import roleService from "../Services/roleService";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import userService from "../Services/userService";
import Dropdown from "../Components/Dropdown";
import SecondaryButton from "../Components/SecondaryButton";
import { FiPlus } from "react-icons/fi";

const AddUser = ({ edit = false }) => {
  const [loading, setLoading] = useState(false);
  const [ID, setID] = useState();
  const [roles, setRoles] = useState([]);
  const [roleDropdown, setRoleDropdown] = useState(false);
  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    role: "",
  });
  const [errors, setErrors] = useState({
    name: false,
    email: false,
    password: false,
    role: false,
  });
  const [regex, setRegex] = useState({
    name: /.{1,50}$/,
    email: /.{1,50}$/,
    password: /.{1,50}$/,
    role: /.{1,50}$/,
  });

  useEffect(() => {
    const getRoles = async () => {
      const response = await roleService.getAll();
      console.log(response);
      setRoles(response.roles);
    };
    getRoles();
  }, []);

  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  useEffect(() => {
    if (edit) {
      if (params.get("id")) {
        roleService.getSingle(params.get("id")).then((res) => {
          setData((d) => ({ ...d, name: res.role.name }));
          setID(res.role.id);
        });
      }
    }
  }, []);

  const handleChange = (e) => {
    setData((d) => ({ ...d, [e.target.name]: e.target.value }));
    setErrors((errs) => ({ ...errs, [e.target.name]: false }));
  };

  const submit = () => {
    setLoading(true);
    let hasError = false;
    Object.keys(data).map((v) => {
      if (!regex[v]?.test(data[v])) {
        setErrors((prevState) => ({ ...prevState, [v]: true }));
        console.log(v);
        hasError = true;
      }
    });

    if (hasError) {
      toast.error("Please fill all the required fields");
      setLoading(false);
    } else {
      if (!edit) {
        userService.create(data).then((res) => {
          navigate("/users");
          setLoading(false);
        });
      } else {
        userService.update(ID, data).then((res) => {
          navigate("/users");
          setLoading(false);
        });
      }
    }
  };

  return (
    <main className="mx-10 mt-2 p-6 rounded-3xl border border-gray-200 shadow-lg bg-white min-h-[calc(100vh-48px)]">
      <p className="font-bold text-3xl text-center mt-10 text-secondary">
        {edit ? "Edit User" : "Add User"}
      </p>

      <div className="mt-10 px-80">
        <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-4">
          <div>
            <label className={`primary-label`}>Name</label>
            <input
              name="name"
              placeholder="Enter name"
              value={data.name}
              onChange={(e) => handleChange(e)}
              className={`primary-input`}
            />
          </div>
          <div>
            <label className={`primary-label`}>Email</label>
            <input
              name="email"
              placeholder="Enter email address"
              value={data.email}
              onChange={(e) => handleChange(e)}
              className={`primary-input`}
            />
          </div>
          {!edit && (
            <div>
              <label className={`primary-label`}>Password</label>
              <input
                name="password"
                placeholder="Enter Password"
                value={data.password}
                onChange={(e) => handleChange(e)}
                className={`primary-input`}
              />
            </div>
          )}
          <div>
            <label className={`primary-label`}>Role</label>
            <Dropdown
              styling="!col-span-3"
              selected={data.role} // pass the selected value (ID)
              placeholder="Select Role"
              onChange={(value) => {
                handleChange({
                  target: {
                    name: "role",
                    value: value,
                  },
                });
              }}
              options={roles.map((r) => ({
                label: r.name, // what you see
                value: r.id, // what is returned
              }))}
            />
          </div>
        </div>
        <div className="flex items-center justify-center mt-10">
          <SecondaryButton
            text={edit ? "EDIT" : "ADD"}
            Icon={FiPlus}
            onClick={() => submit()}
            color="!px-16"
          />
        </div>
      </div>
    </main>
  );
};

export default AddUser;
